module.exports = __webpack_public_path__ + "img/ICMTrader-white.6408dde4.svg";